import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import { IconComponent } from '@/design-system/atoms/icon/icon.component';

@Component({
  selector: 'app-icon-button',
  imports: [IconComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrl: './icon-button.component.scss',
  templateUrl: './icon-button.component.html',
})
export class IconButtonComponent {
  icon = input.required<string>();
  label = input.required<string>();
  size = input(24);
}
